import CakeLayout from '@/layout/CakeLayout/index.vue'

const cakeMap = [
  {
    path: '/cake',
    name: 'Cake',
    component: CakeLayout,
    redirect: 'cake/cake-home',
    children: [
      {
        path: '/cake/cake-home',
        name: 'CakeHome',
        component: () => import('@/views/cakeHome'),
        meta: {
          name: '蛋糕首页',
          keepAlive: true
        },
        icon: {}
      },
      {
        path: '/cake/cake-brands',
        name: 'CakeBrands',
        component: () => import('@/views/cakeBrands'),
        meta: {
          name: '蛋糕品牌'
        },
        icon: {}
      },
      {
        path: '/cake/cake-detail',
        name: 'CakeDetail',
        component: () => import('@/views/cakeDetail'),
        meta: {
          name: '蛋糕详情'
        }
      },
      {
        path: '/cake/cake-brand-detail',
        name: 'CakeBrandDetail',
        component: () => import('@/views/cakeBrandDetail'),
        meta: {
          name: '品牌详情'
        }
      },
      {
        path: '/cake/cake-deliver-goods',
        name: 'CakeDeliverGoods',
        component: () => import('@/views/cakeDeliverGoods'),
        meta: {
          name: '蛋糕配送'
        }
      },
      {
        path: '/cake/cake-to-strore',
        name: 'CakeToStore',
        component: () => import('@/views/cakeToStore'),
        meta: {
          name: '蛋糕到店'
        }
      },
      {
        path: '/cake/cake-store-detail',
        name: 'CakeStoreDetail',
        component: () => import('@/views/cakeStoreDetail/'),
        meta: {
          name: '店铺详情'
        }
      },
      {
        path: '/cake/cake-store-list',
        name: 'CakeStoreList',
        component: () => import('@/views/cakeToStoreList/'),
        meta: {
          name: '店铺列表'
        }
      },
      {
        path: '/cake/cake-card-detail',
        name: 'CakeCardDetail',
        component: () => import('@/views/cakeCardDetail'),
        meta: {
          name: '详情'
        }
      }
    ]
  }
]

export default cakeMap